/** Verlaufsgrafiken: Umfrage mit Ereignissen und Stimmung der Wählergruppen über die Legislatur. */
import { useS } from '../../store/game';
import { Panel } from '../../components/ui';
import { LineChart, GROUP_COLORS, type Marker } from '../../components/charts';
import { GROUPS } from '../../content/axes';
import { PC } from '../../engine/rules';
import { de, dateLabel } from '../../engine/util';
import type { TracePt } from '../../engine/trace';

const PRIO = ['crisis', 'fail', 'scandal', 'budget', 'law', 'ltw'];

function points(S: any, leg?: number): TracePt[] {
  const tr: TracePt[] = S.trace || [];
  const l = leg ?? S.leg;
  return tr.filter((p) => p.leg === l);
}

function markersOf(pts: TracePt[]): Marker[] {
  const out: Marker[] = [];
  pts.forEach((p, i) => {
    if (!p.ev?.length) return;
    const ev = [...p.ev].sort((a, b) => PRIO.indexOf(a.k) - PRIO.indexOf(b.k));
    out.push({ i, kind: ev[0].k, good: ev[0].good, label: ev.map((e) => e.t).join(' · ') });
  });
  return out;
}

/** Umfrage der eigenen Partei mit Ereignissen. */
export function PollChart({ leg, title = 'Umfrage seit der Wahl' }: { leg?: number; title?: string }) {
  const S: any = useS();
  const pts = points(S, leg);
  return (
    <Panel title={title} aside={pts.length ? `${de(pts[pts.length - 1].poll)} %` : undefined}>
      <LineChart title={title} x={pts.map((p) => dateLabel(p.m))} unit=" %" fmt={(v) => de(v, 0)}
        series={[{ id: 'poll', label: S.name, color: PC('YOU'), values: pts.map((p) => p.poll), width: 2.5 }]}
        refLine={S.elec ? { v: S.elec, label: `Wahl ${de(S.elec)} %` } : undefined} markers={markersOf(pts)} />
      {pts.length > 0 && pts.length < 3 && <span className="sub">Der Verlauf füllt sich mit jedem Monat.</span>}
    </Panel>
  );
}

/** Stimmung der fünf Wählergruppen im Verlauf. */
export function GroupChart({ leg }: { leg?: number }) {
  const S: any = useS();
  const pts = points(S, leg);
  if (pts.length < 2) return null;
  return (
    <Panel title="Wählergruppen im Verlauf" aside="Zufriedenheit 0–100">
      <LineChart title="Zufriedenheit der Wählergruppen" x={pts.map((p) => dateLabel(p.m))}
        series={Object.keys(GROUPS).map((g) => ({ id: g, label: GROUPS[g], color: GROUP_COLORS[g], values: pts.map((p) => p.g[g] ?? null) }))} />
    </Panel>
  );
}
